import { milestones } from '@/lib/portfolio';
import { cn } from '@/lib/utils';
import { Reveal } from './Reveal';
import { SectionHeading } from './SectionHeading';

export function Journey() {
  return (
    <section id="journey" className="relative scroll-mt-28 overflow-hidden py-28 md:py-36">
      <div className="absolute -left-40 top-1/3 size-[26rem] rounded-full bg-comet/10 blur-[130px]" aria-hidden="true" />
      <div className="absolute -right-40 bottom-0 size-[26rem] rounded-full bg-blush/10 blur-[130px]" aria-hidden="true" />

      <div className="container relative">
        <SectionHeading
          align="center"
          eyebrow="The flight log"
          title={
            <>
              One year.{' '}
              <span className="font-serif font-normal italic text-flare">Zero chill.</span>
            </>
          }
          description="October 2025 to October 2026 — the speedrun from first hackathon to Safaricom's doorstep."
        />

        <div className="relative mx-auto mt-20 max-w-4xl">
          {/* Rail */}
          <div
            className="absolute bottom-0 left-4 top-0 w-px bg-gradient-to-b from-nova via-pulsar to-blush opacity-40 md:left-1/2"
            aria-hidden="true"
          />

          <div className="space-y-14 md:space-y-20">
            {milestones.map((milestone, i) => {
              const leftSide = i % 2 === 0;
              return (
                <Reveal key={milestone.period} delay={0.05}>
                  <div className="relative pl-12 md:pl-0">
                    {/* Node */}
                    <span
                      className={cn(
                        'absolute left-4 top-2 z-10 size-4 -translate-x-1/2 rounded-full ring-4 ring-background md:left-1/2',
                        milestone.dot,
                      )}
                      aria-hidden="true"
                    />

                    <div
                      className={cn(
                        'md:w-[calc(50%-2.5rem)]',
                        leftSide ? 'md:mr-auto md:text-right' : 'md:ml-auto',
                      )}
                    >
                      <span
                        className={cn(
                          'inline-block rounded-full border border-white/10 bg-card/70 px-4 py-1.5 text-xs font-semibold uppercase tracking-[0.25em] backdrop-blur',
                          milestone.accent,
                        )}
                      >
                        {milestone.period}
                      </span>
                      <h3 className="mt-4 font-display text-2xl font-bold tracking-tight md:text-3xl">
                        {milestone.title}
                      </h3>
                      <p className="mt-3 leading-relaxed text-muted-foreground">
                        {milestone.body}
                      </p>
                      <div
                        className={cn(
                          'mt-4 flex flex-wrap gap-2',
                          leftSide && 'md:justify-end',
                        )}
                      >
                        {milestone.highlights.map((highlight) => (
                          <span
                            key={highlight}
                            className="rounded-full bg-white/5 px-3 py-1 text-xs text-muted-foreground"
                          >
                            {highlight}
                          </span>
                        ))}
                      </div>
                    </div>
                  </div>
                </Reveal>
              );
            })}
          </div>

          {/* Terminal node */}
          <Reveal>
            <div className="relative mt-14 pl-12 md:mt-20 md:pl-0 md:text-center">
              <span
                className="absolute left-4 top-1 size-4 -translate-x-1/2 animate-ping rounded-full bg-foreground/60 md:left-1/2"
                aria-hidden="true"
              />
              <span
                className="absolute left-4 top-1 size-4 -translate-x-1/2 rounded-full bg-foreground md:left-1/2"
                aria-hidden="true"
              />
              <p className="pt-10 font-serif text-2xl italic text-muted-foreground md:pt-12">
                &hellip;and the verse keeps expanding.
              </p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
